const MuiTextField = () => ({
  defaultProps: {
    variant: 'filled',
  },
})

export default MuiTextField
